module.exports = __webpack_public_path__ + "static/media/jammer_white.b1651f85.svg";